export default __webpack_public_path__ + "static/about-8-46952e370c331235dd0b201387737e63.png";